// import 具有最高优先级
import Vue from 'vue'

// 自定义公共样式，以下所有组件库的样式都在此文件内引入
import '@/views/common.scss'

// 公共JS函数库
import common from '@/libs/common'

// 自定义类库
import callApi from '@/libs/callApi';
import Authcheck from '@/libs/Authcheck';

// 前端基础
import store from '@/store'
import router from '@/router'

// 组件样式框架
import ElementUI from 'element-ui'

// 看图组件
import VueViewer from 'v-viewer'

// VXEtable
import 'xe-utils'
import XEUtils from 'xe-utils'
import VXEtable from 'vxe-table'

// 最后引入app
import App from '@/App.vue'

window.$xe = XEUtils;

Vue.prototype.callApi = callApi;
Vue.prototype.$xe = XEUtils;
Vue.prototype.env = process.env;


Vue.use(ElementUI);
Vue.use(VXEtable);
Vue.use(Authcheck);
Vue.use(common);
Vue.use(VueViewer, {
    defaultOptions: {
        zIndex: 9999,
        className: 'vue-viewer'
    }
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
